import { createAction, ExtractActions } from 'modules/react-redux';

export const LOAD_PAGE_DATA = 'COMPANY/LOAD_PAGE_DATA';
export const loadPageData = () => createAction(LOAD_PAGE_DATA, {});

export type Action = ExtractActions<typeof loadPageData>;
